import { useCallback } from "react";
import { usePagination } from "react-instantsearch-hooks";

import { Pagination as BasePagination, useThemeProps } from "../../wsui/base";

export default function Pagination(props) {
  props = useThemeProps({ props, name: "AlgoliaPagination" });
  const {
    // pages,
    currentRefinement,
    // nbHits,
    nbPages,
    // isFirstPage,
    // isLastPage,
    canRefine,
    refine,
    // createURL,
  } = usePagination(props);
  let {
    showFirstButton = false,
    showLastButton = false,
    showPrevButton = false,
    showNextButton = false,
    showLabels = false,
    ...restProps
  } = props;

  const handleChange = useCallback((_, page) => {
    refine(page);
    window.scrollTo(0, 0);
  }, []);

  if (!canRefine) {
    return null;
  }

  return (
    <BasePagination
      page={currentRefinement}
      count={nbPages}
      showFirstButton={showFirstButton}
      showLastButton={showLastButton}
      hidePrevButton={!showPrevButton}
      hideNextButton={!showNextButton}
      showLabels={showLabels}
      onChange={handleChange}
      {...restProps}
    />
  );
}
